
import { useState, useEffect } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  console.log('⏱️ useDebounce вызван:', { value, delay, currentDebouncedValue: debouncedValue });

  useEffect(() => {
    console.log('⏱️ useDebounce effect запущен для значения:', value);
    
    const handler = setTimeout(() => {
      console.log('⏱️ Debounce timeout завершился, устанавливаем:', value);
      setDebouncedValue(value);
    }, delay);

    return () => {
      console.log('⏱️ Debounce timeout отменен для:', value);
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}
